// react core
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import TimeAgo from 'react-timeago'
import { NotificationManager } from 'react-notifications';
import { useNavigate } from "react-router-dom";

// components
import InlineComment from 'components/answers/inline_comment';
import AjaxSpinner from 'components/commons/ajax_spinner';
//import VoteButtons from 'components/answers/vote_buttons';
import VoteButtonsWithState from 'components/answers/vote_buttons_state';
import AuthorLink from 'components/commons/author_link';
import FollowButton from 'components/questions/follow_button';
import TagLink from 'components/commons/tag_link';

// utils
import { clone_object } from 'commons/utils';

// confs
import conf from 'conf/ajax';


export default function QuestionExpanded(props)
{
    const navigate = useNavigate();
    const item = props.item;
    const [show_comment_form, set_show_comment_form] = useState(false);
    const [posting_data, set_posting_data] = useState(false);
    const [show_cmt_btn, set_show_cmt_btn] = useState(true);
    const is_closed = props.item.is_open === false

/*
    const handle_add_comment = (evt) =>
    {
        set_show_comment_form(true);
        set_show_cmt_btn(false);
    };
*/
    const handle_on_cancel = (evt) =>
    {
        set_show_comment_form(false);
        set_show_cmt_btn(true);
    };

    const handle_on_post = (evt, data) =>
    {
        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'POST';
        data_obj.body = JSON.stringify(data);
        set_posting_data(true);
        fetch(conf.endpoints.insertpost, data_obj).then(function (response)
        {
            return response.json();
        }).then(function (data)
        {
            if (data.status === 'ok')
            {
                set_show_comment_form(false);
                set_show_cmt_btn(true);
                set_posting_data(false);
                props.on_comment_post();
            }
        }).catch(error => console.error('Error:', error));
    };

    const handle_remove_button = (evt) =>
    {
        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'DELETE';
        fetch(conf.endpoints.main + conf.server.main_folder + item.id, data_obj ).then(function(response)
        {
            if (!response.ok) {
                throw new Error('Network response was not OK');
            }
        })
        .then(function(data)
        {
            NotificationManager.success('Your question will be removed', 'Ok!');
            navigate(conf.route.main);
            /*setTimeout(() =>
            {
                window.location.href = window.location.origin + conf.route.answer;
            }, 3000);*/
        })
        .catch(function(error) {
            NotificationManager.error('There was an errow while removing your question', 'Sorry');
        });
    }

    return (
        <div id="question-view">

            <div id="question-view-header">
                <h2>{item.title}</h2>
            </div>

            <div id="question-view-body">
                <div>
                    <div>
                        <ReactMarkdown>{item.text}</ReactMarkdown>

                        {item.attachments && item.attachments.length > 0 &&
                        <div className="attachments-wrapper">
                            <label>Attachments</label>
                            <ul>
                            {item.attachments.map(attachment => (
                                <li key={attachment.id}><i className="fa-solid fa-download"></i> <a href={attachment.url} title={`Download: ${attachment.filename} (${attachment.size})`}>{attachment.title}</a> <span></span></li>
                            ))}
                            </ul>
                        </div>
                        }
                    </div>

                    <div id="question-view-body-footer">

                        <div>
                            <div>
                                Asked by <AuthorLink author={item.author} /> <TimeAgo date={item.added_at} minPeriod="60" /> in
                                {item.tags && item.tags.map(tag => (
                                    <span key={tag.id}> <TagLink  tag={tag}/> </span>
                                ))}
                            </div>
                            <div>
                            { is_closed === true &&
                            <>
                                <i className="fa-solid fa-lock"></i> Closed <TimeAgo date={item.closed_at} minPeriod="60" />
                                { item.message &&
                                    <>&nbsp;&mdash; <em>{item.message}</em></>
                                }
                            </>
                            }
                            </div>
                        </div>

                        <div>
                        {item.can_delete &&
                            <button onClick={handle_remove_button} className="button button-small button-discreet"><i className="fa-solid fa-trash"></i> Remove your question</button>
                        }
                        <FollowButton />
                        {/* DISABLED COMMENT BUTTON ON THE QUESTION */}
                        {/* {show_cmt_btn &&
                            <button className="button button-small" onClick={handle_add_comment}><i className="fa-solid fa-comment"></i> Add a comment for the question</button>
                        } */}
                        {item.can_answer && <button onClick={props.on_write_btn}
                            className="button button-primary button-small">
                            <i className="fa-solid fa-reply"></i> Write your answer
                        </button>}
                        </div>

                    </div>

                    {show_comment_form && !posting_data && <InlineComment
                        parent_id={item.id}
                        parent_type="question"
                        on_cacnel={handle_on_cancel}
                        on_post={handle_on_post}
                        can_comment={item.can_comment}
                    />}
                    {show_comment_form && posting_data && <AjaxSpinner />}

                </div>
                <div>
                    <VoteButtonsWithState
                        id={item.id}
                        type="question"
                        can_vote={item.can_vote}
                    />
                    <div>{item.view_count} {item.view_count == 1 ? 'view' : 'views'}</div>
                </div>

            </div>




        </div>
    );
};

QuestionExpanded.defaultProps =
{
    item:
    {
        vote_count: 0
    }
}
